module.exports = __webpack_public_path__ + "static/img/5555.7381c1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/5555.jpg
// module id = lEJ7
// module chunks = 1